import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tab, Tabs, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Navigation, UserScreen } from '@professocial/professocialTypes/types/commonTypes'

import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  SocialmediaConnection,
  SocialmediaConnectionState
} from '@professocialApi/professocial-core-frontend-api/models'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api/models/UserSettings'

type IProps = {
  user: UserSettings | undefined
  navigationList: Navigation[]
  naviChanged: boolean
  setNaviChange?: (naviChanged: boolean) => void
};

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    position: 'sticky',
    width: '100%',
    top: theme.spacing(10),
    zIndex: 98,
    backgroundColor: theme.palette.primary.main,
    '& .MuiTabs-indicator': { height: '3px', backgroundColor: theme.palette.common.white },
    '& .MuiTab-root': { fontSize: '1rem', padding: theme.spacing(1.5, 2.5), color: theme.palette.primary.contrastText },
    '& .Mui-selected': { color: theme.palette.primary.contrastText, fontWeight: 700 },
  },
}))

const NavigationBar: React.FC<IProps> = React.memo(({ user, navigationList, naviChanged, setNaviChange }) => {
  const classes = useStyles()
  const history = useHistory()
  const { t } = useTranslation()

  const [value, setValue] = React.useState<UserScreen | false>(false)

  const connections = user?.smConnections?.find((connection: SocialmediaConnection) => connection.state === SocialmediaConnectionState.Connected)

  const handleChange = (event: React.SyntheticEvent, newValue: UserScreen) => {
    setValue(newValue)
  }

  useEffect(() => {
    if (navigationList && navigationList[0]) {
      const pathname = window.location.pathname
      const path = pathname.split('/')
      const hasLocation = navigationList.find(item => item.key === path[2])

      if (hasLocation) {
        setValue(hasLocation.key as UserScreen)
      } else {
        path.includes('login') && user && history.push(`/${user ? user.role.toLowerCase() : 'user'}/`)
        setValue(navigationList[0].key as UserScreen)
      }
    }
  }, [navigationList])

  useEffect(() => {
    !naviChanged && setValue(false)
  }, [naviChanged])

  const navToSettingsValue = (value: string) => connections ? value : 'settings/connect'

  return (
    <>
      <Tabs
        value={value}
        indicatorColor='secondary'
        className={classes.tabs}
        onChange={handleChange}
      >
        {navigationList && navigationList.map(navItem => {
          return (
            <Tab
              component={Link}
              to={`/${user ? user.role.toLowerCase() : 'user'}/${user?.role === 'USER' ? navToSettingsValue(navItem.value) : navItem.value}`}
              label={`${t('coreNavigation:' + navItem.label)}`}
              value={navItem.key}
              key={navItem.key}
              onClick={() => setNaviChange && setNaviChange(true)}
            />
          )
        })}
      </Tabs>

    </>
  )
})

NavigationBar.displayName = 'NavigationBar'

NavigationBar.propTypes = {
  user: PropTypes.object,
  navigationList: PropTypes.array.isRequired,
  naviChanged: PropTypes.bool.isRequired,
  setNaviChange: PropTypes.func,
}

export default NavigationBar
